export default "__VITE_ASSET__vGlyybke__"